// 定义 Lenis 接口
interface LenisInstance {
    on(event: string, callback: (args: { scroll: number; direction: number }) => void): void;
    scrollTo(target: number | string | HTMLElement, options?: any): void;
}

const initMenu = (lenis: LenisInstance) => {
    const body = document.body;
    const toggleMenuBtn = document.querySelector('.js-nav-toogle');
    const gotop = document.querySelector('.js-gotop');

    const header = document.querySelector('.header') as HTMLElement;

    let headerH = header.offsetHeight;

    // console.log(headerH);
    // 滚动处理
    lenis.on('scroll', ({ scroll, direction }) => {
        // console.log(scroll, direction);
        body.classList.toggle('fixed-menu', scroll > headerH);
        body.classList.toggle('drop-menu', direction > 0);
    });

    // 菜单按钮 (移动端)
    toggleMenuBtn?.addEventListener('click', () => {
        body.classList.toggle('menu-open');
    });

    // 防止resize时触发菜单transition
    let resizeTimer: any;
    window.addEventListener('resize', () => {
        document.body.classList.add('resizing');
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove('resizing');
            headerH = header.offsetHeight;
        }, 300);
    });

    // 返回顶部
    gotop?.addEventListener('click', () => {
        lenis.scrollTo(0);
    });
}

export { initMenu }
